/**
 * Profile service — profile, cash accounts, desired withdrawal.
 * @module services/profileService
 */
import { api } from "../lib/api";

export const profileService = {
  /** @returns {Promise<import("./types").Profile|null>} */
  get: () => api.get("/profile").then((r) => r.data),

  /**
   * @param {Partial<import("./types").Profile>} payload
   * @returns {Promise<import("./types").Profile>}
   */
  update: (payload) => api.put("/profile", payload).then((r) => r.data),

  /**
   * @param {{amount:number,reason?:string}} payload
   * @returns {Promise<{desired_withdrawal:number,withdrawal_reason:string}>}
   */
  setWithdrawal: ({ amount, reason }) =>
    api.put("/desired-withdrawal", { amount, reason }).then((r) => r.data),

  /** Wipe the optional persona fields (age, risk, horizon, etc.). */
  reset: () => api.post("/profile/reset").then((r) => r.data),
};

export const cashAccountsService = {
  /** @returns {Promise<import("./types").CashAccount[]>} */
  list: () => api.get("/cash-accounts").then((r) => r.data),

  /**
   * @param {Omit<import("./types").CashAccount,"id">} payload
   * @returns {Promise<import("./types").CashAccount>}
   */
  create: (payload) => api.post("/cash-accounts", payload).then((r) => r.data),

  /**
   * @param {string} id
   * @param {Omit<import("./types").CashAccount,"id">} payload
   * @returns {Promise<import("./types").CashAccount>}
   */
  update: (id, payload) => api.put(`/cash-accounts/${id}`, payload).then((r) => r.data),

  /**
   * @param {string} id
   * @returns {Promise<{ok:true}>}
   */
  remove: (id) => api.delete(`/cash-accounts/${id}`).then((r) => r.data),
};
